const LOOPBACK_HOSTS = new Set(["localhost", "127.0.0.1", "[::1]", "::1"])

function isPrivateNetworkHost(hostname: string): boolean {
    if (LOOPBACK_HOSTS.has(hostname)) return true

    const ipv4 = hostname.split(".")
    if (ipv4.length === 4 && ipv4.every((part) => /^\d{1,3}$/.test(part))) {
        const octets = ipv4.map(Number)
        if (octets.some((octet) => octet > 255)) return false
        return octets[0] === 10 || (octets[0] === 172 && octets[1] >= 16 && octets[1] <= 31) || (octets[0] === 192 && octets[1] === 168) || octets[0] === 127
    }

    const ipv6 = hostname.startsWith("[") && hostname.endsWith("]") ? hostname.slice(1, -1) : hostname
    const firstHextet = ipv6.match(/^([0-9a-f]{1,4}):/i)?.[1]
    if (!firstHextet) return false
    return (Number.parseInt(firstHextet, 16) & 0xfe00) === 0xfc00
}

function isPrivateNetworkHttpUrl(value: string): boolean {
    try {
        const url = new URL(value)
        return url.protocol === "http:" && !url.username && !url.password && isPrivateNetworkHost(url.hostname)
    } catch {
        return false
    }
}

export function isAllowedBrowserUrl(value: string): boolean {
    if (value === "about:blank") return true
    try {
        const url = new URL(value)
        if (url.username || url.password) return false
        return url.protocol === "https:" || url.protocol === "http:"
    } catch {
        return false
    }
}

export function normalizeManualBrowserInput(value: string): string {
    const input = value.trim()
    if (!input) return "about:blank"
    if (isAllowedBrowserUrl(input)) return input
    if (isPrivateNetworkHttpUrl(`http://${input}`)) return `http://${input}`
    if (/^[a-z][a-z0-9+.-]*:/i.test(input)) return input
    if (/^[\w.-]+(?::\d+)?(?:\/.*)?$/.test(input) && input.includes(".")) return `https://${input}`
    return `https://www.google.com/search?q=${encodeURIComponent(input)}`
}
